module.exports = __webpack_public_path__ + "img/21.d00ccd58.png";